/**
 * The Etusivu week strip: four counts side by side in one card, separated by
 * hairline dividers. `tone="crit"` turns a number red — used only for genuinely
 * overdue work.
 */

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface WeekStripStat {
  label: string;
  value: number;
  tone?: "default" | "crit";
}

export function WeekStrip({ stats }: { stats: WeekStripStat[] }) {
  return (
    <Card className="grid grid-cols-2 divide-x divide-y divide-border sm:grid-cols-4 sm:divide-y-0">
      {stats.map((stat) => (
        <div key={stat.label} className="px-6 py-5">
          <div className="text-sm leading-5 text-muted-foreground">{stat.label}</div>
          <div
            className={cn(
              "mt-1.5 text-2xl font-semibold leading-8 tabular-nums",
              stat.tone === "crit" && stat.value > 0
                ? "text-red-600"
                : "text-foreground",
            )}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </Card>
  );
}
